module.exports = "/virtual-football-league/img/amblems/right/logos/Liverpool.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Liverpool.png
// module id = 2211
// module chunks = 4